import React, {useEffect} from 'react';
import '../styles/Pages.css';

const Quadronizei = () => {
    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/1230b8162917589.63dd232b99278.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/636d93162917589.63dd232b9b6f2.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/527c54162917589.63dd232b9845d.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/04f472162917589.63dd232b94e19.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5a1b57162917589.63dd232b9780b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5f4832162917589.63dd232ba522b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/fc9f68162917589.63dd232ba2faa.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d2e87a162917589.63dd232ba46a0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/cfb903162917589.63dd232b9ed39.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/c0159b162917589.63dd232bacf85.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/764261162917589.63dd232b95ce5.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/f67861162917589.63dd232ba9e9f.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/e766a9162917589.63dd232b9ab3c.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/13b0d9162917589.63dd232ba03f4.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/9143d8162917589.63dd232b9c340.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/39e80e162917589.63dd232ba8d94.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/bc230e162917589.63dd232b9cfe9.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/e58866162917589.63dd232ba0f3c.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/15cce6162917589.63dd232b9f8b5.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/2f56f1162917589.63dd232ba7c48.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/ea7010162917589.63dd232b9e125.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/22feb3162917589.63dd232ba3b41.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/64388b162917589.63dd232b99ec4.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/182409162917589.63dd232ba69dd.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/da6a6c162917589.63dd232ba219c.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/46f90f162917589.63dd232baab00.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/e63c5a162917589.63dd232ba5e94.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/564853162917589.63dd232bac393.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/314223162917589.63dd232baf259.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/e1e054162917589.63dd232bab75d.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/498c05162917589.63dd232badb3c.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/6162f0162917589.63dd232bae6d3.png'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };

      }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Quadronizei</h1>
                    <p className="subtitle">Transforme sua casa no seu mundo Nerd</p>
                </div>
                <div className="pages-right">
                    <p className="description">
                    Quadronizei é uma loja virtual de quadros nerds que tem como objetivo transformar a casa das pessoas no mundo nerd delas. Quadronizei produz quadros decorativos focando no tema geek para amantes da ficção, como animes, filmes, séries, jogos, etc.
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Centro de Convivência Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default Quadronizei;
